const prenom   = document.getElementById('prospect_livre_first_name');
const email    = document.getElementById('prospect_livre_email');
const checkbox = document.getElementById('prospect_livre_check_consent');
const submit   = document.getElementById('form-submit');

const regExNames = /^[a-zàáâäçèéêëìíîïñòóôöùúûüÂÇÉÈÊËÎÏÔÖÙÜ ,.'-]+$/i;
const regExEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

let prenomCheck   = 0;
let emailCheck    = 0;
let checkboxCheck = 0;
let totalCheck    = 0;

function checkForm() {
  totalCheck = prenomCheck + emailCheck + checkboxCheck;
  if (totalCheck == 3) {
    submit.removeAttribute('disabled');
    document.querySelector('.tooltip-popup').removeAttribute('tooltip-popup');
  } else {
    submit.setAttribute('disabled', 'disabled');
    document.querySelector('.tooltip-popup').setAttribute('tooltip-popup', 'Tu dois remplir le formulaire et cocher la case');
  }
};

function debounce(func, timeout = 900){
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

function checkPrenom(){
  if (regExNames.test(prenom.value)) {
    prenomCheck = 1;
    document.getElementById('prenom-alert').style.display = "none";
  } else {
    prenomCheck = 0;
    document.getElementById('prenom-alert').style.display = "block";
  }
  checkForm();
};

function checkEmail(){
  if (regExEmail.test(email.value)) {
    emailCheck = 1;
    document.getElementById('email-alert').style.display = "none";
  } else {
    emailCheck = 0;
    document.getElementById('email-alert').style.display = "block";
  }
  checkForm();
}

const emailChanges = debounce(() => checkEmail());

document.addEventListener('DOMContentLoaded', () => {
  prenom.addEventListener('input', checkPrenom);

  if (prenom && prenom.value.trim() !== "") {
    checkPrenom();
  };

  email.addEventListener('input', emailChanges);

  if (email && email.value.trim() !== "") {
    checkEmail();
  };

  checkbox.addEventListener('change', (e) => {
    if (e.target.checked) {
      checkboxCheck = 1;
    } else {
      checkboxCheck = 0;
    }
    checkForm();
  });
});
